const MtrSettingsOutline={
    "name": "mtr-settings",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "fill": "currentColor",
                    "fill-rule": "evenodd",
                    "d": "M6 9.17V5a1 1 0 1 0-2 0v4.17a3.001 3.001 0 0 0 0 5.66V19a1 1 0 0 0 2 0v-4.17a3.001 3.001 0 0 0 0-5.66zm7 5V5a1 1 0 0 0-2 0v9.17a3.001 3.001 0 1 0 2 0zm7-4.34V19a1 1 0 0 1-2 0V9.83a3.001 3.001 0 1 1 2 0zM19 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-7 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm-7-5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                }
            }
        ]
    }
};
export default MtrSettingsOutline;